module.exports = __webpack_public_path__ + "static/media/CNX-CNX-10.a34b313d.jpg";